module.exports = __webpack_public_path__ + "static/media/banner_13.cf98e0e8.jpg";